import { Route, Routes } from 'react-router-dom';
import { ContactUs } from '../components/ContactUs/ContactUs';
import { CreateEditFleet } from '../components/FleetEstimator/CreateEditFleet';
import { PrintEstimate } from '../components/FleetEstimator/Results/PrintEstimate';
import { ViewEstimate } from '../components/FleetEstimator/Results/ViewEstimate';
import { SampleFleets } from '../components/FleetEstimator/SampleFleets';
import { AddEditVehicleSets } from '../components/FleetEstimator/VehicleSets/AddEditVehicleSets';
import { ViewFleets } from '../components/FleetEstimator/ViewFleets/ViewFleets';
import { Home } from '../components/Homepage/Home';
import Login from '../components/Login';
import { MyAccount } from '../components/MyAccount/MyAccount';
import { NewsAndEvents } from '../components/NewsAndEvents/NewsAndEvents';
import { PrivacyStatement } from '../components/PrivacyPolicy/PrivacyStatement';
import { ProgramOverview } from '../components/ProgramOverview/ProgramOverview';
import { ChargingStationLocator } from '../components/Resources/ChargingStationLocator';
import { ElectricVehicleSupplyEquipment } from '../components/Resources/ElectricVehicleSupplyEquipment/ElectricVehicleSupplyEquipment';
import { ElectricVehicles } from '../components/Resources/ElectricVehicleFundamentals/ElectricVehicles';
import { Basics } from '../components/Resources/ElectricVehicleBasics/ElectrificationBasics';
import { FundingSources } from '../components/Resources/FundingSources/FundingSources';
import { VehicleCatalog } from '../components/Resources/VehicleCatalog/VehicleCatalog';
import { PageNotFound } from '../components/Shared/PageNotFound';
import { TermsOfUse } from '../components/TermsOfUse';
import { Layout } from '../layouts/Layout';
import { PrintLayout } from '../layouts/PrintLayout';

const Routers = () => {

    return (
        <Routes>
            <Route element={<Layout />} >
                <Route path='/' element={<Home />} />
            </Route>
            <Route element={<PrintLayout />} >
                <Route path='/PrintResults/:fleetIDParam' element={<PrintEstimate />} />
            </Route>
            <Route element={<Layout />} >
                <Route path='/ChargingStationLocator' element={<ChargingStationLocator />} />
                <Route path='/ContactUs' element={<ContactUs />} />
                <Route path='/ProgramOverview' element={<ProgramOverview />} />
                <Route path='/MyAccount' element={<MyAccount />} />
                <Route path='/PrivacyStatement' element={<PrivacyStatement />} />
                <Route path='/TermsOfUse' element={<TermsOfUse />} />
                <Route path='/Login' element={<Login />} />
                <Route path='/ElectrificationBasics' element={<Basics />} />
                <Route path='/ElectricVehicles' element={<ElectricVehicles />} />
                <Route path='/ElectricVehicleSupplyEquipment' element={<ElectricVehicleSupplyEquipment />} />
                <Route path='/VehicleCatalog' element={<VehicleCatalog />} />
                <Route path='/FundingSources' element={<FundingSources />} />
                <Route path='/NewsAndEvents' element={<NewsAndEvents />} />
                <Route path='/CreateFleet' element={<CreateEditFleet />} />
                <Route path='/FleetEstimator' element={<CreateEditFleet />} />
                <Route path='/EditFleet/:fleetIDParam' element={<CreateEditFleet />} />
                <Route path='/AddVehicleSets/:fleetIDParam' element={<AddEditVehicleSets />} />
                <Route path='/EditVehicleSet/:fleetIDParam/:vehicleSetIDParam' element={<AddEditVehicleSets />} />
                <Route path='/ViewFleets' element={<ViewFleets />} />
                <Route path='/ViewEstimate/:fleetIDParam' element={<ViewEstimate />} />
                <Route path='*'  element={<PageNotFound />} />
                <Route path='/Home/:errorParam' element={<Home />} />
                <Route path='SampleFleets' element={<SampleFleets />} />

                <Route path="/authentication/callback" element={<div>Loading session...</div>} />
                <Route path="/authentication/silent-callback" element={<div />} />
            </Route>
        </Routes>
    );
};

export default Routers;
